<template>
  <div class="section-heading">
    {{ $t(textKey) }}
  </div>
</template>

<script>
export default {
  name: 'SectionHeading',
  props: {
    textKey: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.section-heading {
  width: 100%;
  padding: 28px 16px;
  text-align: center;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 24px;
  color: #000;
}

@media screen and (min-width: 768px) {
  .section-heading {
    padding-top: 32px;
    padding-bottom: 32px;
    font-size: 32px;
  }
}

@media screen and (min-width: 1280px) {
  .section-heading {
    padding-top: 40px;
    padding-bottom: 40px;
    font-size: 40px;
  }
}
</style>
